/* eslint-disable @typescript-eslint/no-explicit-any */
import { saveHandler } from './save-handler';
import { displayLoadingModal } from '../components/utils';
import { mainTheme } from '@/mainTheme';
import { modalUtils } from '@/app/core/utils';
import { createStandaloneToast } from '@chakra-ui/react';
import { ProgramDataType } from '@ssar-app/domain';

export const handleSave = async (
  programName: string,
  draftId: string,
  programId: string,
  data: ProgramDataType,
  exitProgram: boolean,
  isAutoSave: boolean,
): Promise<{ newDraftId: string; newProgramId: string }> => {
  const toast = createStandaloneToast({ theme: mainTheme });
  const toReturn = { newDraftId: '', newProgramId: '' };
  let closeModal: any = null;
  if (!isAutoSave) {
    closeModal = displayLoadingModal('Saving of program is in progress...');
  }
  await saveHandler(programName, draftId, programId, data as ProgramDataType)
    .then((saveProps) => {
      if (saveProps.error !== '') {
        if (!isAutoSave) {
          modalUtils.showError(saveProps.error);
        }
      } else {
        if (!exitProgram) {
          toReturn.newDraftId = saveProps.draftId;
          toReturn.newProgramId = saveProps.programId;
          if (isAutoSave) {
            toast({
              status: 'success',
              title: 'Program Auto Saved',
              position: 'top',
              variant: 'left-accent',
            });
          } else {
            modalUtils.showSuccessMessage('Program saved Successfully.');
          }
        }
      }
    })
    .catch((error) => {
      if (!isAutoSave) {
        modalUtils.showError(error);
      }
    })
    .finally(() => {
      if (closeModal) {
        closeModal();
      }
    });
  return toReturn;
};
